module.exports = __webpack_public_path__ + "img/page_image_3_3.9d13c1c7.svg";